import React, { useState } from "react";

const SharedImage = ({
  src,
  alt,
  width,
  height,
  className = "",
  fallback = null,
  fixed = false,
  rounded = false,
  onClick = () => {},
  hover = false,
  ...props
}) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  return (
    <div onClick={onClick}
      className={`relative ${fixed ? "shrink-0" : ""} ${rounded ? "rounded-full overflow-hidden" : ""} ${hover ? "hover:scale-[1.03] transition-all duration-300" : ""}`}
      style={{
        width: fixed ? `${width}px` : width,
        height: fixed ? `${height}px` : height
      }}
    >
      {loading && !error && (
        <div className="absolute inset-0 flex items-center justify-center animate-pulse rounded">
          <div className="w-3/4 h-3/4 bg-gray-300 rounded" />
        </div>
      )}

      <img
        src={error && fallback ? fallback : src}
        alt={alt}
        className={`object-contain w-full h-full transition-opacity duration-500 ${
          loading ? "opacity-0" : "opacity-100"
        } ${className}`}
        onLoad={() => setLoading(false)}
        onError={() => {
          setError(true);
          setLoading(false);
        }}
        {...props}
      />
    </div>
  );
};

export default SharedImage;
